import { requestCreateFavouriteList } from '../../request/backendApi/favourites/createFavouriteList';

export const createFavouriteList = (name: string) => requestCreateFavouriteList(name);
